import { useGetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQuery } from '@/hooks/search/search.gql.impl';
import {
  GetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQuery,
  HospitalSortType,
} from '@/types/bff/gql-schema';
import { SearchHospitalVo } from '@/types/hospital';
import { SearchResult } from '@/types/search';
import { getDiagnosisStateOfOperatingStatus, getFormattedReviewTotalCount, getReviewScore } from '@/utils/format';

const KEYWORD_SEARCH_SIZE = 4;

const parseKeywordIntegratedSearchHospital = (
  data: GetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQuery
): SearchResult<SearchHospitalVo> => {
  return {
    hasMore: data.diseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPage.elements.length > 3,
    elements: data.diseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPage.elements
      .slice(0, 3)
      .map((hospital) => {
        return {
          ...hospital,
          hospitalTotalCount: 0,
          hospitalRepresentativeDepartmentName: hospital?.hospitalRepresentativeDepartmentName || '',
          reviewScore: getReviewScore(hospital.reviewAverageRating),
          reviewCount: getFormattedReviewTotalCount(hospital.reviewTotalCount),
          hospitalOperationStatus: getDiagnosisStateOfOperatingStatus(hospital.hospitalOperationStatus),
          doctors: hospital.doctors.filter((doctor) => !!doctor),
        };
      }),
  };
};

const useGetKeywordIntegratedSearchHospital = (keyword: string, latitude: number, longitude: number) => {
  const { data: keywordSearchHospital, isLoading: isKeywordSearchHospitalLoading } =
    useGetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQuery(
      {
        request: {
          keyword,
          size: KEYWORD_SEARCH_SIZE,
          sortType: HospitalSortType.Distance,
          geoPoint: {
            latitude,
            longitude,
          },
        },
      },
      {
        select: parseKeywordIntegratedSearchHospital,
        enabled: keyword.length > 1,
      }
    );

  return {
    keywordSearchHospital,
    isKeywordSearchHospitalLoading,
  };
};

export default useGetKeywordIntegratedSearchHospital;
